<template>
  <div class="tj-page">
    <ViewComp :detail="detail">
      <div v-if="hasHistory" class="back-btn" @click="goBack()"></div>
      <!-- 评论 -->
      <PageComment :detail="detail" />
      <!-- 侧边栏 -->
      <AsideBar v-show="asideBarStyle.left" :detail="detail" :customStyle="asideBarStyle" />
    </ViewComp>
  </div>
</template>

<script>
import ViewComp from "./view/index.vue";

import AsideBar from "./components/asideBar.vue";
import PageComment from "./components/pageComment.vue";
// api
import { apiContentDetail } from "@/api/contentApi";

export default {
  name: "PageDetailZSTJ",
  components: { ViewComp, AsideBar, PageComment },
  data() {
    return {
      detail: {},
      hasHistory: false,
      asideBarStyle: {}
    };
  },

  watch: {
    $route: function(val) {
      if (val.name !== "wikiSecondsNav") {
        this.getDetail();
      }
    }
  },
  mounted() {
    if (window.history.length > 1) {
      this.hasHistory = true;
    } else {
      this.hasHistory = false;
    }
    // 获取内容
    this.getDetail();

    // 监听resize
    window.addEventListener("resize", this.refreshAsideBarStyle);
    setTimeout(() => {
      this.refreshAsideBarStyle();
    }, 1000);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.refreshAsideBarStyle);
  },
  methods: {
    goBack() {
      window.history.back();
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
    },
    // 获取文章详情
    async getDetail() {
      let { params } = this.$route;
      let id = params.id.split("_")[0];

      try {
        const res = await apiContentDetail({ id });
        if (res.code == 0) {
          this.detail = res.data;

          if (this.detail.editor_type != 3) {
            this.$router.replace({
              path: `/${this.alias}/rich-table?id=${this.detail.id}&entry_id=${this.detail.entry_id}&title=${this.detail.title}`
            });
            return;
          }
          const routeMeta = this.$route.meta;
          // 文章关联weiki和当前wiki不匹配，返回对应wiki详情；
          if (!routeMeta.noWikiRoute && this.detail.game.alias != this.gameInfo.alias) {
            const url = `/${this.detail.game.alias}/tj/${id}.html`;
            window.location.replace(url);
            return;
          }
        }
      } catch (err) {
        // 文章审核中
        if (err && err.code === 100002) {
          this.detail = {
            isUnderReview: 1
          };
          return;
        }
        // 文章禁用
        if (err && err.code === 100010) {
          this.detail = {
            audit_state: -1
          };
          return;
        }
        if (err && err.code == 1002 && err.msg == "文章不存在: record not found") {
          // 没有文章信息，重定向到404
          this.$router.replace("/404");
        }
      }
    },
    /**
     * 计算点赞、评论侧边栏的位置，应始终吸附在主题内容右上角
     */
    refreshAsideBarStyle() {
      const el = document.querySelector(".tj-container .wrapper");
      if (!el) return;
      const { right, top } = el.getBoundingClientRect();
      this.asideBarStyle = {
        left: `${right + 20}px`,
        top: `${top}px`
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
